@if (mappedMacromolecules().length === 0) {
  <div class="no-domain-parent">
    <div class="no-domain-information">No macromolecule information available</div>
    <div class="no-domain-notes">Macromolecule annotations will appear here if data becomes available in future updates.</div>
  </div>
}

@if (mappedMacromolecules().length > 0) {
  <div>
    <main class="tab-parent" [class.change-display]="!isSidebarDisplayed()">
      @if(isSidebarDisplayed()){
        <interactive-left-table
          tabName="Macromolecules"
          [tedDomainData]="mappedMacromolecules()"
          (handleSelectedCard)="handleSelectedCard($event)" />
      }
      <div class="tab-content">
        @let icon = isSidebarDisplayed() ? 'left' : 'right'; @let text = isSidebarDisplayed() ? 'Open full-width' : 'Show Macromolecules';
        <button class="vf-button-ghost" (click)="toggleSidebar()">
          <img [src]="'assets/img/two_arrows_' + icon + '.png'" alt="arrow icons" width="16" height="16" />
          <span class="openclosetext">{{ text }}</span>
        </button>
        <h5 class="domain-title">
          <strong>{{ activeMacromolecule()?.uniprotDescription || 'Not named' }}</strong>
        </h5>
        <section class="domain-info">
          <div class="domain-info-grouped">
            <div class="info-row">
              <span>Gene</span>
              <article>{{ activeMacromolecule()?.gene || 'Not available' }}</article>
            </div>
            <div class="info-row">
              <span>Source organism</span>
              <article><i>{{ activeMacromolecule()?.organismScientificName || 'Not available' }}</i></article>
            </div>
            <div class="info-row">
              <span>UniProt</span>
              <article>
                {{ activeMacromolecule()?.uniprotAccession }}
                @if (activeMacromoleculeRange(); as range) {
                  @if (range.start !== 1) {
                    [residues: {{ range.start }} – {{ range.end }}]
                  }
                }
                @if (activeMacromolecule()?.uniprotAccession) {
                  <a
                    [href]="'https://www.uniprot.org/uniprotkb/' + activeMacromolecule()?.uniprotAccession"
                    target="_blank"
                    (click)="gaService.eventEmitter('external_link_click', 'external_resources', 'click', 'uniprot_link', 'Clicks on UniProt link')"
                    class="vf-link ext"
                    >
                    go to UniProt
                  </a>
                }
                @if (!activeMacromolecule()?.uniprotAccession) {
                  <span>Not available</span>
                }
              </article>
            </div>
            <div class="info-row">
              <span>Biological function</span>
              <article>
                @if (isBiologicalFunctionLoading()) {
                  <span>Loading...</span>
                }
                @if (!isBiologicalFunctionLoading() && isBiologicalFunctionExpanded()) {
                  <span [innerHTML]="biologicalFunction().text"></span>
                }
                @if (!isBiologicalFunctionLoading() && isBiologicalFunctionExpanded() && canShowMoreBiologicalFunction()) {
                  <a
                    class="vf-link"
                    (click)="toggleBiologicalFunctionText()"
                    >
                    Show less
                  </a>
                }
                @if (!isBiologicalFunctionLoading() && !isBiologicalFunctionExpanded()) {
                  <span [innerHTML]="getShortenedBiologicalFunctionText()"></span>
                }
                @if (!isBiologicalFunctionLoading() && !isBiologicalFunctionExpanded() && canShowMoreBiologicalFunction()) {
                  <a
                    class="vf-link"
                    (click)="toggleBiologicalFunctionText()"
                    >
                    Show more
                  </a>
                }
                @if (!isBiologicalFunctionLoading() && biologicalFunction().source && biologicalFunction().source !== 'tooltip') {
                  <a
                    [href]="biologicalFunction().source_url"
                    target="_blank"
                    class="vf-link ext"
                    >
                    go to {{ biologicalFunction().source }}
                  </a>
                }
              </article>
            </div>
          </div>
          <div class="domain-info-grouped">
            <div class="info-row">
              <span style="min-width:200px">Also a component in</span>
              <article>
                @if (isAlsoComponentInLoading()) {
                  <span>Loading...</span>
                }
                @if (!isAlsoComponentInLoading() && alsoComponentInCount() !== null) {
                  <span>
                    {{ alsoComponentInCount() }} entries in AFDB
                    @if (activeMacromolecule()?.uniprotAccession) {
                      <a
                        [href]="'/search/text/' + activeMacromolecule()?.uniprotAccession"
                        class="vf-link ext"
                        style="margin-left: 0px;"
                        target="_blank"
                        (click)="onRelatedEntryClick('also_component_in')"
                        >
                        go to search
                      </a>
                    }
                  </span>
                }
                @if (!isAlsoComponentInLoading() && alsoComponentInCount() === null) {
                  <span>Not available</span>
                }
              </article>
            </div>
            <div class="info-row">
              <span style="min-width:200px">Experimental structures</span>
              <article>
                <span>
                  @if (kbCount > 0) {
                    <span>{{kbCount}} PDB structures for {{activeMacromolecule()?.uniprotAccession}}  <br /><a [href]="'https://www.ebi.ac.uk/pdbe/pdbe-kb/proteins/' + activeMacromolecule()?.uniprotAccession" target="_blank" style="margin-left: 0px;" class="vf-link ext" (click)="onRelatedEntryClick('go_to_KB')">go to PDBe-KB</a> </span>
                  }
                  @if (kbCount === 0) {
                    <span>None available in the PDB </span>
                  }
                </span>
              </article>
            </div>
          </div>
        </section>
        <section>
          <div class="sequence-container">
            <div class="title">
              @if (!showChainDropdown()) {
                <span class="chaintext">{{ getActiveChainTitle() }}</span>
              }
              @if (showChainDropdown()) {
                <entry-dropdown
                  [downloadable]="false"
                  [islink]="false"
                  [options]="chainDropdownOptions"
                  [title]="getActiveChainTitle()"
                  (optionClickedEvent)="onChainDropdownSelect($event)">
                </entry-dropdown>
              }
              <div class="label-tooltip-seq" style="display: inline">
                @if (isCopySequence) {
                  <span class="label-tooltip-seq-text">Sequence copied</span>
                }
                <button (click)="copySequence(getActiveSequenceForCopy())">Copy sequence</button>
              </div>
            </div>
            <div class="macromolecules-sequencepanel"></div>
          </div>
        </section>
        <section class="molstar-details-container">
          <div class="threedwrapper">
            <!-- *ngIf="entryData().paeDocUrl" -->
            <div class="paecontainer">
              <app-pae-view
                [accession]="accession"
                [paeid]="'macromolecules-paeviewer'"
                [paeDocUrl]="entryData().paeDocUrl"
                [imageUrl]="entryData().paeImageUrl"
                [length]="entryData().sequenceEnd"
                (selectedRegion)="cmSelectionUpdate($event)">
              </app-pae-view>
            </div>
          </div>
          <div class="threedcontainer">
            <div class="macromolecules-molstar-container"></div>
            <section class="domain-info quality-stats">
              <div class="domain-info-grouped first-group">
                <span class="metrics-title">{{ getActiveChainTitle() }} quality</span>
                <div class="info-row">
                  <div class="plddtlegends">
                    <span class="plddt-label smalltext">Average pLDDT
                      <help-icon-with-tooltip style="margin-left: 4px;" [tooltipText]="'Mean pLDDT score for residues across the full-length protein. Indicates AlphaFold confidence.'" [isOnlytext]="false" />
                    </span>
                    @if (activeMacromolecule()?.globalMetricValue !== null && activeMacromolecule()?.globalMetricValue !== undefined) {
                      <span class="plddtlegends smalltext">
                        {{ activeMacromolecule()?.globalMetricValue }} ({{ getPlddtLevel(activeMacromolecule()?.globalMetricValue) }})
                      </span>
                    }
                    @if (activeMacromolecule()?.globalMetricValue === null || activeMacromolecule()?.globalMetricValue === undefined) {
                      <span>Not available</span>
                    }
                  </div>
                </div>
                @if (hasPlddtDistribution()) {
                  <div class="info-row plddt-summary plddt-distribution-block">
                    <span class="smalltext">pLDDT distribution</span>
                    <article style="display:flex; flex-direction: row;">
                      <div>
                        <div class="plddtlegends">
                          <span class="legendColor" style="background-color: #0053d6;">&nbsp;</span>
                          {{ (activeMacromolecule()?.fractionPlddtVeryHigh * 100) | number : '1.0-1' }}% Very high
                        </div>
                        <div class="plddtlegends">
                          <span class="legendColor" style="background-color: #65cbf3;">&nbsp;</span>
                          {{ (activeMacromolecule()?.fractionPlddtConfident * 100) | number : '1.0-1' }}% High
                        </div>
                        <div class="plddtlegends">
                          <span class="legendColor" style="background-color: #ffdb13;">&nbsp;</span>
                          {{ (activeMacromolecule()?.fractionPlddtLow * 100) | number : '1.0-1' }}% Low
                        </div>
                        <div class="plddtlegends">
                          <span class="legendColor" style="background-color: #ff7d45;">&nbsp;</span>
                          {{ (activeMacromolecule()?.fractionPlddtVeryLow * 100) | number : '1.0-1' }}% Very low
                        </div>
                      </div>
                    </article>
                  </div>
                }
              </div>
              <div class="domain-info-grouped">
                <span class="metrics-title">Interface quality</span>
                <div class="info-row">
                  <article style="display:flex; flex-direction: row;">
                    <div>
                      <div class="plddtlegends">
                        <span class="plddt-label">ipSAE<help-icon-with-tooltip style="margin-left: 4px;" [tooltipText]="'Interaction prediction score from aligned errors (ipSAE) focuses on inter-chain residue pairs with more reliable predicted positioning, making it less sensitive to disordered or non-interacting regions.'" [isOnlytext]="false" /></span>
                        <span>{{complexData().complexPredictionAccuracy_ipSAE}} ({{ getipSAELevel(complexData().complexPredictionAccuracy_ipSAE) }})
                        </span>
                      </div>
                      <div class="plddtlegends">
                        <span class="plddt-label">ipTM<help-icon-with-tooltip style="margin-left: 4px;" [tooltipText]="'Interface predicted TM-score (ipTM) measures confidence in the predicted relative positions of the protein chains in a complex.'" [isOnlytext]="false" /></span>
                        <span>{{complexData().complexPredictionAccuracy_ipTM}}</span>
                      </div>
                      <div class="plddtlegends">
                        <span class="plddt-label">pDockQ2<help-icon-with-tooltip style="margin-left: 4px;" [tooltipText]="'Estimates the expected quality of an interface by combining local residue confidence with confidence in the predicted relative positioning across the interface.'" [isOnlytext]="false" /></span>
                        <span>{{complexData().complexPredictionAccuracy_pDockQ2}}</span>
                      </div>
                      <div class="plddtlegends">
                        <span class="plddt-label">LIS<help-icon-with-tooltip style="margin-left: 4px;" [tooltipText]="'Local Interaction Score (LIS) is derived from low PAE regions and reflects local confidence in the predicted interaction interface.'" [isOnlytext]="false" /></span>
                        <span>{{complexData().complexPredictionAccuracy_LIS}}</span>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </section>
            <!-- <linear-legends type="plddt"></linear-legends> -->
          </div>
        </section>
      </div>
    </main>
  </div>
}